/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetSubscriptionStatusQueryResponse, GetSubscriptionStatus400, GetSubscriptionStatus401, GetSubscriptionStatus404, GetSubscriptionStatus409, GetSubscriptionStatus500 } from "../../types/GetSubscriptionStatus.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetSubscriptionStatusUrl() {
  const res = { method: 'GET', url: `/api/me/subscription` as const }
  return res
}

/**
 * @description Returns the full subscription status for the current user's organisation — including trial days remaining, seat counts, Stripe customer status, and affiliate code. Use this to render in-app upsell banners.
 * @summary Get subscription status
 * {@link /api/me/subscription}
 */
export async function getSubscriptionStatus(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSubscriptionStatusQueryResponse, ResponseErrorConfig<GetSubscriptionStatus400 | GetSubscriptionStatus401 | GetSubscriptionStatus404 | GetSubscriptionStatus409 | GetSubscriptionStatus500>, unknown>({ method : "GET", url : getGetSubscriptionStatusUrl().url.toString(), ... requestConfig })
  return res.data
}